(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  if (typeof Swiper !== "undefined") {
    new Swiper(".responsive-slider", {
      loop: true,

      autoplay: {
        delay: 6000, // 7 seconds
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },

      navigation: {
        nextEl: ".responsive-slider .swiper-button-next",
        prevEl: ".responsive-slider .swiper-button-prev",
      },

      pagination: {
        el: ".responsive-slider .swiper-pagination",
        clickable: true,
      },

      grabCursor: true
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
